import type { ReactNode } from 'react';

export interface QuestionCardProps {
  questionNumber: number;
  children: ReactNode;
  /** 已格式化难度文案，如「难度 · B1」；无难度时不传 */
  levelLabel?: string;
}

export function QuestionCard({ questionNumber, children, levelLabel }: QuestionCardProps) {
  return (
    <article className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
      <div className="px-5 py-6 sm:px-8 sm:py-8">
        <div className="mb-4 flex items-center justify-between gap-3">
          <p className="text-sm font-semibold text-primary-600">第 {questionNumber} 题</p>
          {levelLabel ? (
            <span className="rounded-md border border-primary-200 bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-700">
              {levelLabel}
            </span>
          ) : null}
        </div>
        {children}
      </div>
    </article>
  );
}
